import(/* webpackMode: "eager" */ "/home/u445189188/domains/tasyle.com/public_html/.builds/source/tasyle/src/app/contact/page.tsx");
